import React from "react";
import { Select, Space, Typography } from "antd";
import { CalendarOutlined } from "@ant-design/icons";

const { Option } = Select;
const { Text } = Typography;

const DateRangeSelector = ({ value, onChange, disabled = false }) => {
  const dateRangeOptions = [
    { value: 7, label: "Last 7 days" },
    { value: 14, label: "Last 14 days" },
    { value: 30, label: "Last 30 days" },
    { value: 60, label: "Last 60 days" },
    { value: 90, label: "Last 90 days" },
    { value: 180, label: "Last 6 months" },
    { value: 365, label: "Last year" },
  ];

  const handleChange = (newValue) => {
    if (onChange) {
      onChange(newValue);
    }
  };

  return (
    <Space>
      <CalendarOutlined style={{ color: "#1890ff" }} />
      <Text strong>Analytics Period:</Text>
      <Select
        value={value}
        onChange={handleChange}
        disabled={disabled}
        style={{ minWidth: 150 }}
        placeholder="Select date range"
      >
        {dateRangeOptions.map((option) => (
          <Option key={option.value} value={option.value}>
            {option.label}
          </Option>
        ))}
      </Select>
    </Space>
  );
};

export default DateRangeSelector;
